/**
 * PersonProfilePageLayout — responsive person archive layout with optional left profile card.
 * Third column appears when insightPanel is provided (wide desktop — expanded or collapsed).
 * Below 2xl, callers place guidance inline in the main column where it fits best.
 */
import React from 'react';
import { cn } from '@/lib/utils';

export function PersonProfilePageLayout({ leftAside = null, insightPanel = null, children, className }) {
  const hasLeft = Boolean(leftAside);
  const hasInsight = Boolean(insightPanel);
  const threeColumn = hasLeft && hasInsight;

  return (
    <div
      className={cn(
        'grid grid-cols-1 gap-6 md:gap-8',
        hasLeft && 'lg:grid-cols-[minmax(220px,280px)_minmax(0,1fr)]',
        threeColumn && '2xl:grid-cols-[minmax(220px,280px)_minmax(0,1fr)_minmax(260px,300px)]',
        hasLeft && !hasInsight && 'lg:grid-cols-[minmax(220px,280px)_minmax(0,1fr)]',
        !hasLeft && hasInsight && '2xl:grid-cols-[minmax(0,1fr)_minmax(260px,300px)]',
        className,
      )}
      data-testid="person-profile-page-layout"
    >
      {leftAside ? (
        <div className="min-w-0 lg:sticky lg:top-6 lg:self-start">{leftAside}</div>
      ) : null}
      <div className={cn('min-w-0', threeColumn && '2xl:col-start-2')}>{children}</div>
      {hasInsight ? (
        <div className="hidden min-w-0 2xl:block 2xl:sticky 2xl:top-6 2xl:self-start">{insightPanel}</div>
      ) : null}
    </div>
  );
}

export default PersonProfilePageLayout;
